module.exports = __webpack_public_path__ + "static/media/edit.f28405a4.svg";